import { render, staticRenderFns } from "./itemTwo.vue?vue&type=template&id=8f8e4e0a"
import script from "./itemTwo.vue?vue&type=script&lang=js"
export * from "./itemTwo.vue?vue&type=script&lang=js"
import style0 from "./itemTwo.vue?vue&type=style&index=0&id=8f8e4e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports